<template>
    <div ref="scrollTarget"></div>
    <MainNav />

    <section class="laptop-section" style="margin-top: 50px; margin-bottom: 150px; padding-top: 65px">
        <div class="container" style="padding-top: 80px;">
            <div class="row">
                <div class="col-6 text-center">
                    <p style="text-align: left; padding-left: 45px; font-weight: 600; color: #CF0020; text-transform: uppercase; font-size: 1.3em;">
                        {{ translate('login_text1') }}
                    </p>
                    <p style="text-align: left; padding-left: 45px; font-weight: 600; color: #CF0020; font-size: 1.3em;">
                        {{ translate('login_text2') }}
                    </p>
                    <img src="../assets/img/login_image.jpg" style="margin-top: 15px;">
                </div>
                <div class="col-6 text-center">
                    <div class="border" style="border-radius: 15px; padding-top: 80px; padding-bottom: 80px; color: black; font-size: 1.3em;">
                        {{ translate('form_header') }}
                        <br>
                        <a class="btn btn-danger btn-connect" :href="log2xLoginUrl">{{ translate('login') }}</a>
                        <br>
                        <p style="margin-top: 50px; font-weight: 600">{{ translate('not_yet_subscribed') }}</p>
                        <button style="margin-top: 30px;" class="btn btn-danger btn-connect">{{ translate('subscribe') }}</button>
                    </div>
                </div>
            </div>
        </div>  
    </section>

    <section class="ipad-section" style="margin-bottom: 150px; padding-top: 65px">
        <div class="container" style="padding-top: 80px;">
            <div class="row">
                <div class="col-12 text-center">
                    <p style="text-align: center; font-weight: 600; color: #CF0020; text-transform: uppercase; font-size: 1.3em;">
                        {{ translate('login_text1') }}
                    </p>
                    <p style="text-align: center; font-weight: 600; color: #CF0020; font-size: 1.3em;">
                        {{ translate('login_text2') }}
                    </p>
                    <img src="../assets/img/login_image.jpg" style="margin-top: 15px;">
                </div>
                <div class="col-12 text-center">
                    <div class="border" style="border-radius: 15px; padding-top: 80px; padding-bottom: 80px; color: black; font-size: 1.3em; margin-top: 20px;">
                        {{ translate('form_header') }}
                        <br>
                        <a class="btn btn-danger btn-connect" :href="log2xLoginUrl">{{ translate('login') }}</a>
                        <br>
                        <p style="margin-top: 50px; font-weight: 600">{{ translate('not_yet_subscribed') }}</p>
                        <button style="margin-top: 30px;" class="btn btn-danger btn-connect">{{ translate('subscribe') }}</button>
                    </div>
                </div>
            </div>
        </div>  
    </section>

    <section class="mobile-section" style="margin-bottom: 150px; padding-top: 65px">
        <div class="container" style="padding-top: 80px;">
            <div class="row">
                <div class="col-12 text-center">
                    <p style="text-align: center; font-weight: 600; color: #CF0020; text-transform: uppercase; font-size: 1.3em;">
                        {{ translate('login_text1') }}
                    </p>
                    <p style="text-align: center; font-weight: 600; color: #CF0020; font-size: 1.3em;">
                        {{ translate('login_text2') }}
                    </p>
                    <img src="../assets/img/login_image.jpg" style="margin-top: 15px;">
                </div>
                <div class="col-12 text-center">
                    <div class="border" style="border-radius: 15px; padding-top: 80px; padding-bottom: 80px; color: black; font-size: 1.3em; margin-top: 20px;">
                        {{ translate('form_header') }}
                        <br>
                        <a class="btn btn-danger btn-connect" :href="log2xLoginUrl">{{ translate('login') }}</a>
                        <br>
                        <p style="margin-top: 50px; font-weight: 600">{{ translate('not_yet_subscribed') }}</p>
                        <button style="margin-top: 30px;" class="btn btn-danger btn-connect">{{ translate('subscribe') }}</button>
                    </div>
                </div>
            </div>
        </div>  
    </section>

</template>


<script>
import axios from 'axios';
import MainNav from '@/components/MainNav2.vue';
import en from '@/en.js';
import fr from '@/fr.js';
import nl from '@/nl.js';

// La vitrine ne demande plus ni identifiant ni mot de passe : jusqu'au
// 23/09/2026 elle les écrivait dans l'adresse (WOPS_CIT?uname=…&upass=…),
// donc dans l'historique du navigateur et les journaux des serveurs.
// La page de connexion Log2X, elle, envoie le mot de passe hors de l'adresse.
const LOG2X_LOGIN_URL = 'https://www.citexpress.net/WOPS_CIT';

export default {
    mixins: [en, fr, nl],
    components: {
        MainNav
    },
    data() {
        return {
            lang: this.$store.state.lang,
            log2xLoginUrl: LOG2X_LOGIN_URL
        }
    },
    computed: {
        lang2() {
            return this.$store.state.lang
        }
    },
    mounted() {
        document.title = 'CITExpress | Login';
        const element = this.$refs.scrollTarget;
        element.scrollIntoView({ behavior: 'smooth' });
        // Même nombre de clics qu'avant : on arrive directement sur la page
        // Log2X. replace() retire /login de l'historique, donc « Retour »
        // ramène à la page précédente au lieu de relancer la redirection.
        window.location.replace(LOG2X_LOGIN_URL);
    },
    methods: {
        translate(prop) {
            return this[this.lang2][prop];
        }
    }
}
</script>



<style>
.custom-input{
    border-radius: 8px;
    border: 1px solid #9B9B9B;
    background-color: #F5F5F5;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 300px;
}
.btn-connect{
    background-color: #CF0020;
    border-radius: 8px;
    border: none;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-top: 50px;
}
.btn-connect:hover{
    background-color: #940B20;
}
.btn-connect:focus{
    background-color: #940B20;
}
</style>